import dynamic from 'next/dynamic';
const SUPPORTED_PROVIDERS = {
  youtube: dynamic(() => import(/* webpackChunkName: "blazePbVideoYouTube" */'./YouTube/YouTubeProvider')),
  JWPlayer: dynamic(() => import(/* webpackChunkName: "blazePbVideoJWPlayer" */'./JWPlayer/JWPlayerProvider')),
  vimeo: dynamic(() => import(/* webpackChunkName: "blazePbVideoVimeo" */'./Vimeo/VimeoProvider')),
  default: dynamic(() => import(/* webpackChunkName: "blazePbVideoDefault" */'./Default')),
  html: dynamic(() => import(/* webpackChunkName: "blazePbVideoDefault" */'./Default'))
};
function getProvider(provider) {
  return SUPPORTED_PROVIDERS[provider] || SUPPORTED_PROVIDERS.default;
}
export default getProvider;
//# sourceMappingURL=get-provider.js.map